import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import SectionTitle from "../ui/SectionTitle";
import Container from "../ui/Container";

const statsData = [
  { num: 15, label: "Групп в неделю", suffix: "+" },
  { num: 8, label: "Стилей танца" },
  { num: 150, label: "Учеников", suffix: "+" },
  { num: 1, label: "Урок бесплатно", suffix: "-й" },
];

const Stats: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const section = document.getElementById("stats-section");
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setVisible(true);
      },
      { threshold: 0.25 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="stats-section" className="py-24 lg:py-36 2xl:py-48 bg-brand-white sticky top">
      <Container>
      <div className="grid-text mb-16">
        <SectionTitle 
          title="Немного о нас" 
          subtitle="" 
        />
      </div>
        <div/>
        {/* Цифры */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-16 mb-16 text-center">
          {statsData.map((stat, i) => (
            <StatItem
              key={i}
              num={stat.num}
              label={stat.label}
              suffix={stat.suffix}
              visible={visible}
              delay={i * 100}
            />
          ))}
        </div>

        {/* Карта */}
        <div className="w-full rounded-4xl overflow-hidden mb-6
                        h-[320px] md:h-[480px] lg:h-[520px] xl:h-[600px]">
          <iframe
            title="ул. Тюленина, 5"
            src="https://www.google.com/maps?q=ул.+Тюленина,+5,+Омск,+Омская+обл.,+644100&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Адрес */}
        <ul className="text-brand-dark text-sm md:text-base text-center">
          <li className="flex items-center justify-center gap-3">
            <MapPin className="shrink-0 text-brand-primary" size={18} />
            <span className="leading-relaxed">
              ул. Тюленина, 5
            </span>
          </li>
        </ul>
      </Container>
    </section>
  );
};

interface StatItemProps {
  num: number;
  label: string;
  suffix?: string;
  visible: boolean;
  delay: number;
}

const StatItem: React.FC<StatItemProps> = ({
  num,
  label,
  suffix,
  visible,
  delay,
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!visible) return;
    let current = 0;
    const duration = 1500;
    const stepTime = 20;
    const steps = duration / stepTime;
    const increment = num / steps;

    const timer = setInterval(() => {
      current += increment;
      if (current >= num) {
        current = num;
        clearInterval(timer);
      }
      setCount(Math.floor(current));
    }, stepTime);

    return () => clearInterval(timer);
  }, [visible, num]);

  return (
    <div
      className={`transition-all duration-700 ease-out ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="display-lg md:display-xl text-brand-primary mb-1">
        {count}
        {suffix || ""}
      </div>
      <div className="body-sm md:body-base text-brand-dark font-medium">
        {label}
      </div>
    </div>
  );
};

export default Stats;
